import { render, staticRenderFns } from "./ConfigMosaicoForm.vue?vue&type=template&id=022979cc&scoped=true"
import script from "./ConfigMosaicoForm.vue?vue&type=script&lang=js"
export * from "./ConfigMosaicoForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigMosaicoForm.vue?vue&type=style&index=0&id=022979cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022979cc",
  null
  
)

export default component.exports